import { TitleRowTabBeneficiaries } from 'components/TitleRowTabBeneficiaries';
import { PaymentsEmployedsItem } from 'ui/PaymentsEmployedsItem';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { useGetTabEmployedsQuery } from 'redux/Api/employedsWorkSupportApi/employedsWorkSupportApi';
import { Nothing } from 'components/Nothing';
import styles from './Payments.module.scss';
import {
  QueryParamsTabEmployedsType,
  ResponseTabEmployedsPaymentsType,
} from 'redux/Api/employedsWorkSupportApi/type';

export const Payments = ({ id = 0, title }: QueryParamsTabEmployedsType) => {
  const { data, isLoading, error } = useGetTabEmployedsQuery({ id, title });

  const dataPayments = ['id', 'Заказчик', 'Тип платежа', 'Сумма', 'Статус'];

  return (
    <div className={styles.root}>
      <TitleRowTabBeneficiaries data={dataPayments} title='paymentsEmployeds' />
      {error || !data?.length ? (
        <Nothing
          style={{ height: '640px' }}
          title={error ? 'Ошибка, попробуйте позже' : 'Ничего не найдено'}
        />
      ) : isLoading ? (
        <LoadingSkeleton tabDetails />
      ) : (
        (data as ResponseTabEmployedsPaymentsType[])?.map((elem, i) => (
          <PaymentsEmployedsItem payment={elem} key={i} />
        ))
      )}
    </div>
  );
};
